export const AccountTypeInitial = {
  Kitchen_Accounts: "active",
  Host_Accounts: "",
};
export const handleClick = (setDisplayValue, setFunction, value) => {
  const newObject = {
    Kitchen_Accounts: "",
    Host_Accounts: "",
  };
  if (value === "Kitchen_Accounts") {
    setDisplayValue("kitchen");
  } else if (value === "Host_Accounts") {
    setDisplayValue("host");
  }
  setFunction({ ...newObject, [value]: "active" });
};
